import * as LINKS from '../constants/links';

const links = {
    "links": [
        // {
        //     "name": "youtube",
        //     "link": LINKS.youtube
        // },
        {
            "name": "main website",
            "link": LINKS.website
        },
        {
            "name": "AMBIENT Loops Vol 1",
            "link": LINKS.ambientloops
        },
        // {
        //     "name": "buy music",
        //     "link": LINKS.bandcamp
        // }
    ]
}

export default links